// extracted by css-extract-rspack-plugin
export default {"emailWrapper":"AgentDetails_emailWrapper__yV9iD"};